import { useState } from "react";
import { updateUserBusinessRole } from '../../redux/actions/addUser';

import { useDispatch} from "react-redux";
import '../../../src/styles/login.css';
import { url } from '../../api/endpointURL';

// Import generic components
import Input from "../../generic_components/Input/Input";
import Button from "../../generic_components/Button/Button";
import { useToast } from "../../generic_components/Toast/Toast";



const NewBusiness = ({onBusinessSubmitSuccess, onClose, email}) => {
    const [business, setBusiness] = useState('');
    const toast = useToast();

    const dispatch = useDispatch();

    // const isSmallScreen = window.innerWidth < 600;

    const handleBusinessChange = (e) => {
        setBusiness(e.target.value);
    };

    // Check if the business input is valid. Should be in this format "BUSINESS" OR "BUSINESS-TEST" 
    const isBusinessValid = (businessName) => {
        const regex = /^[A-Z]+(-[A-Z]+)*-?$/;
        return regex.test(businessName);
    };

    // Modify the entered business name
    const cleanBusinessName = (businessName) => {
        // Trim leading and trailing spaces. Then replace the inner spaces with dashes
        let trimmed_businessName = businessName.trim().replace(/\s+/g, '-');
        return trimmed_businessName.toUpperCase();
    };

    const handleNewBusiness = async(e) => {
        e.preventDefault();
        // If the business name is invalid 
        if (!isBusinessValid(cleanBusinessName(business))) {
            toast.error("The business name is invalid. Please try again.", {
                hideProgressBar: true,
            });
        }
        // If the business name is valid
        else {
            const payload = {
                business: cleanBusinessName(business)
            }
            try {
                const response = await fetch(`${url}/validate-business`, {
                    method: 'POST',
                    headers: {
                    'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(payload),  
                });

                const businessExists = await response.json();

                let message = '';
                // If business exists meaning unavailable
                if (businessExists === true) {
                    message = 'Business already exists. Please try again.'            
                    toast.error(message, {
                        hideProgressBar: true,
                    });
                }
                // If business doesn't exist meaning available
                else if (businessExists === false) {
                    // Update the business and role (L2) in USERS table and add a business entry in BUSINESS_TOKEN_MAPPING table
                    if (email && cleanBusinessName(business)) {
                        message = 'Success! Your business has been created.'
                        toast.success(message, {
                            hideProgressBar: true,
                            autoClose: 9000
                        });
                        const userData = {email: email, business: cleanBusinessName(business)}
                        dispatch(updateUserBusinessRole(userData))
                        onClose(); // close the Business form
                        onBusinessSubmitSuccess();
                    }
                    else {
                        message = 'Email or business name is empty. Please try again.'            
                        toast.error(message, {
                            hideProgressBar: true,
                        });
                    }
                    
                } 
            }
            catch (error) {
                console.error('Error:', error);
            }
        }
    };

    return (
        <>
        <form onSubmit={handleNewBusiness}>
            <div>
                {/* <input id='input-box-business'              
                    required
                    type="text"
                    placeholder="Enter a business..."
                    value={business}
                    onChange={handleBusinessChange}
                    minLength={1}
                /> */}
                <Input             
                    required
                    type="text"
                    placeholder="Enter a business..."
                    value={business}
                    onChange={handleBusinessChange}
                    size='lg'
                    // minLength={1}
                />
                {/* If business is invalid, show warning message */}
                {(business && !isBusinessValid(cleanBusinessName(business))) &&
                <div>
                    <small style={{color:'var(--gm3-sys-color-error,#b3261e)', fontSize: '0.75rem'}}>
                        <i class="fa-solid fa-circle-exclamation" style={{color: "#da1616;"}}></i> Sorry, only letters (a-z) and spaces ( ) or hyphens (-) are allowed 
                        (e.g. Capital One, Capital-One)
                    </small>
                </div>
                }
                <Button className='signup-submit-btn' type='submit' disabled={business.length > 0 ? false : true}>Submit</Button>
            </div>
        </form>

        </>
    )
}

export default NewBusiness;